import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconFindMyCarProps } from './IconFindMyCar.types'
import * as Styled from './styles/IconFindMyCar.style'

import { nonThemeableRules } from '../../ruleSet'

const IconFindMyCar: FC<IconFindMyCarProps> = ({
  size = nonThemeableRules.defaultSize as number as IconFindMyCarProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconFindMyCarProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='m2.996 10.84 7.844-7.848a1.648 1.648 0 0 1 2.32 0l7.848 7.848c.637.64.637 1.68 0 2.32l-7.848 7.848c-.64.637-1.68.637-2.32 0L2.996 13.16a1.64 1.64 0 0 1 0-2.32Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path d='M9.492 15.527v-4.039H16.5' vectorEffect='non-scaling-stroke' />
          <path d='m13.656 8.61 2.86 2.855-2.907 2.906' vectorEffect='non-scaling-stroke' />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconFindMyCar
